import { logger, safeError } from '../../../utils/logger';
import { useEffect, useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loading } from '../../../components/Loading';

export const AuthCallback = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { handleCognitoAuth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate(); // usado para errores de errorCode

  useEffect(() => {
    // Procesar la redirección y obtener los datos de autenticación
    const processAuthentication = async () => {
      try {
        // Verificar si hay un código de error en la URL
        logger.log(
          '[AUTH-CALLBACK] ===== processAuthentication START =====',
        );
        logger.log(
          '[AUTH-CALLBACK] location.search:',
          location.search,
        );
        logger.log(
          '[AUTH-CALLBACK] location.pathname:',
          location.pathname,
        );
        logger.log('Procesando autenticación...');
        const urlParams = new URLSearchParams(location.search);
        const errorCode = urlParams.get('error');
        logger.log('[AUTH-CALLBACK] errorCode:', errorCode);

        if (errorCode) {
          // login_required / interaction_required = no hay sesión en Cognito (respuesta normal de prompt=none)
          if (
            errorCode === 'login_required' ||
            errorCode === 'interaction_required'
          ) {
            logger.log('Sin sesión Cognito activa, mostrando login');
            navigate('/login', { replace: true });
            return;
          }
          setError(`Error de autenticación: ${errorCode}`);
          setTimeout(() => {
            navigate('/login');
          }, 3000);
          return;
        }

        // Esperar un poco para que las cookies se establezcan correctamente
        logger.log(
          '[AUTH-CALLBACK] Esperando 2s para que las cookies se establezcan...',
        );
        await new Promise((resolve) => setTimeout(resolve, 2000));
        logger.log(
          '[AUTH-CALLBACK] Espera terminada, llamando a handleCognitoAuth...',
        );

        // Proceder con la autenticación
        logger.log('Llamando a handleCognitoAuth...');
        await handleCognitoAuth();
      } catch (error) {
        logger.error('Error al procesar la autenticación:', safeError(error));
        setError(
          'Ocurrió un error durante el proceso de autenticación. Redirigiendo al inicio de sesión...',
        );
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } finally {
        setIsLoading(false);
      }
    };

    processAuthentication();
  }, [handleCognitoAuth, location.search, navigate]);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100">
      {isLoading && <Loading />}
      {isLoading && <p className="mt-4 text-center"></p>}
      {error && (
        <div className="alert alert-danger mt-4">{error}</div>
      )}
    </div>
  );
};
